export default "__VITE_ASSET__DqmHHxiR__"